module.exports = __webpack_public_path__ + "img/footer_company_05.99996de5.png";